import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFormData } from '@/store/slices/formDataSlice'

const GeoPosition: React.FC = () => {
  const dispatch = useDispatch()
  const formData = useSelector((state: any) => state.formData)
  const [geoError, setGeoError] = useState<string | null>(null)

  const getLocation = (cb?: () => void) => {
    if (window.location.hostname === 'srv1') {
      dispatch(setFormData({ latitude: -1, longitude: -1 }))
      return
    }

    const success = (position: GeolocationPosition) => {
      console.log('Position:', position)
      const latitude = position.coords.latitude
      const longitude = position.coords.longitude

      dispatch(setFormData({ latitude, longitude }))
      if (typeof cb === 'function') {
        cb()
      }
    }

    const error = (e: GeolocationPositionError) => {
      console.log('location error', e)
      setGeoError(e.message)
      if (typeof cb === 'function') {
        cb()
      }
    }

    setGeoError(null)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(success, error)
    }
  }

  const skip = () => {
    dispatch(setFormData({ geoSkipped: true }))
  }

  const lsOverride = window.localStorage.getItem('_geo_override')
  
  return (
    <div className="lvl-tm geo-banner-container step__main">
      <div className="geo-banner step__main__inner">
        <React.Fragment>
          <div className="heading-and-button">
            <h1>Enhetens posisjon</h1>
            {(lsOverride || formData.geoCollectionMode === 'skippable') && (
              <span className="link" onClick={skip}>
                Hopp over
              </span>
            )}
          </div>
          <div className="infobox">
            Posisjonen til denne enheten er ikke tilgjengelig<span onClick={skip}>.</span>
          </div>
        </React.Fragment>
        <div className="geo-expl">
          Før du kan ta i bruk verktøyet må vi bestemme enhetens posisjon. Trykk på knappen under
          og svar Ja/OK på evt. spørsmål som dukker opp.
        </div>
        <div className="buttons">
          <button onClick={() => getLocation()}>Hent posisjon</button>
        </div>
        {geoError && (
          <div className="geo-error-container">
            <div className="geo-error-outro">Oida, teknisk feil:</div>
            <div className="geo-error">{geoError}</div>
            <div className="geo-error-outro">
              Vi kunne ikke bestemme enhetens posisjon. Ta kontakt med IT-ansvarlig
            </div>
            <div className="geo-error-outro buttons">
              <button onClick={() => getLocation()}>Prøv igjen</button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default GeoPosition